"use client";

import { ATTRIBUTION_COOKIE_NAME, parseAttributionCookie } from "./attribution";

interface LeadSubmitInput {
  formId: string;
  formType: string;
  vehicleId?: string;
  pagePath: string;
}

interface PhoneClickInput {
  phone: string;
  vehicleId?: string;
  pagePath?: string;
}

declare global {
  var dataLayer: unknown[] | undefined;
}

function readAttributionFromDocument(): Record<string, string> {
  if (typeof document === "undefined") {
    return {};
  }
  const cookieStr = document.cookie
    .split(";")
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${ATTRIBUTION_COOKIE_NAME}=`));
  if (!cookieStr) {
    return {};
  }
  const raw = decodeURIComponent(cookieStr.slice(ATTRIBUTION_COOKIE_NAME.length + 1));
  const attr = parseAttributionCookie(raw);
  if (!attr) {
    return {};
  }
  const out: Record<string, string> = {};
  if (attr.utmSource) {
    out.utm_source = attr.utmSource;
  }
  if (attr.utmMedium) {
    out.utm_medium = attr.utmMedium;
  }
  if (attr.utmCampaign) {
    out.utm_campaign = attr.utmCampaign;
  }
  if (attr.utmTerm) {
    out.utm_term = attr.utmTerm;
  }
  if (attr.utmContent) {
    out.utm_content = attr.utmContent;
  }
  if (attr.gclid) {
    out.gclid = attr.gclid;
  }
  if (attr.fbclid) {
    out.fbclid = attr.fbclid;
  }
  if (attr.ttclid) {
    out.ttclid = attr.ttclid;
  }
  if (attr.msclkid) {
    out.msclkid = attr.msclkid;
  }
  if (attr.referrer) {
    out.referrer = attr.referrer;
  }
  if (attr.landingPage) {
    out.landing_page = attr.landingPage;
  }
  return out;
}

function push(payload: Record<string, unknown>): void {
  if (!globalThis.dataLayer) {
    console.warn("[analytics] dataLayer is missing — skipping event");
    return;
  }
  globalThis.dataLayer.push(payload);
}

export function fireLeadSubmit(input: LeadSubmitInput): void {
  const payload: Record<string, unknown> = {
    event: "lead_submit",
    form_id: input.formId,
    form_type: input.formType,
    page_path: input.pagePath,
    ...readAttributionFromDocument(),
  };
  if (input.vehicleId !== undefined) {
    payload.vehicle_id = input.vehicleId;
  }
  push(payload);
}

export function firePhoneClick(input: PhoneClickInput): void {
  const payload: Record<string, unknown> = {
    event: "phone_click",
    phone: input.phone,
    page_path: input.pagePath,
    ...readAttributionFromDocument(),
  };
  if (input.vehicleId !== undefined) {
    payload.vehicle_id = input.vehicleId;
  }
  push(payload);
}
